<template>
    <div class="navbars custom ">
        <b-navbar
                type="light"
                variant="default"
                :sticky="true"
                class="justify-content-start justify-content-md-between">
            <b-navbar-brand href="/home" id="logoPage" class="position-relative mr-0 mr-sm-3 logo-mobile"
                            :class="{'d-block':isOpenMenu}">
                <img src="../../../../static/assets/img/logo.svg" alt="" class="app-logo">

                <span class="spliter two d-none d-sm-block"></span>
            </b-navbar-brand>

            <b-nav-item-dropdown class="custom-dropdown-logo d-none pt-4" right
                                 :class="{'d-block':isOpenMenu}">

                <b-dropdown-item @click.prevent="logout()" class="other-logo">
                    <img src="../../../../static/assets/img/upperSAYopinion.svg" alt="">
                </b-dropdown-item>
            </b-nav-item-dropdown>

            <div class="nav-left  ">

                <b-btn variant="link"
                       class="btn-open-sidebar"
                       @click="toggleSidebarClass()">
          <span class="icon   align-self-center"
                :class="isOpenMenu ? 'icon-menu_close' : 'icon-menu_open'"
          ></span>
                </b-btn>
                <h2 class="align-self-center">{{$t('Witamy w')}} <span>upperSAY clean</span></h2>
            </div>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown class="custom-drop" right>
                        <template slot="button-content" class="">
              <span class="text-right ">
                  {{profile.name}} {{profile.surname}}
              </span>

                        </template>
                        <b-dropdown-item :to="{name:'admin.profile.change'}">{{$t('Profil')}}</b-dropdown-item>
                        <b-dropdown-item :to="{name:'admin.profile.change-password'}">{{$t('Zmiana hasła')}}
                        </b-dropdown-item>
                        <b-dropdown-item @click.prevent="logout()">{{$t('Wyloguj')}}</b-dropdown-item>
                    </b-nav-item-dropdown><!--
                    <div class="d-none d-md-block box-info-icon px-3 text-center">
                        <span class="count-message ">2</span> <br>
                        <span class="icon icon-alerty"></span>
                    </div>-->
                    <div class=" d-md-block box-info-icon px-3 text-center">
                        <span class="count-message ">2</span> <br>

                        <div
                                class="justify-content-center d-flex flex-shrink-0">
                            <b-dropdown class="custom no-arrow dropdown-massage"
                                        variant="link">
                                <template slot="text" class="asdasd">
                                    <span class="icon icon-alerty"></span>
                                </template>
                                <perfect-scrollbar :style="{height:'200px'}">
                                    <b-dropdown-item href="#" class="border-bottom py-3">content</b-dropdown-item>
                                    <b-dropdown-item href="#" class="border-bottom py-3">Lorem ipsum dolor sit amet,
                                        consectetur adipisicing elit. Dolor?
                                    </b-dropdown-item>
                                    <b-dropdown-item href="#" class="border-bottom py-3">Lorem ipsum dolor sit amet.
                                    </b-dropdown-item>
                                    <b-dropdown-item href="#" class="py-3">Lorem ipsum dolor sit amet.</b-dropdown-item>
                                </perfect-scrollbar>
                            </b-dropdown>
                        </div>
                    </div>

                    <span class="spliter  d-md-block"></span>
                    <b-nav-item-dropdown :text="selectedLang" right class="d-md-block ">
                        <b-dropdown-item v-for="lang in languages" @click="changeSelectedLang(lang.code)"
                                         v-if="lang.code !== selectedLang">
                            {{lang.code}}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

    </div>
</template>

<script>
import EventBus from '@/event-bus.js'

export default {
  name: 'Navbar',
  mixins: [],
  data () {
    return {
      isOpenMenu: true
    }
  },
  computed: {
    profile () {
      return JSON.parse(this.$store.getters.profile)
    },
    languages () {
      return this.$store.getters.languages
    },
    selectedLang () {
      return this.$store.getters.selectedLang
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({
          name: 'LoginView',
          params: { nextUrl: this.$route.path }
        })
      })
    },
    toggleSidebarClass () {
      this.isOpenMenu = !this.isOpenMenu
      EventBus.$emit('TOGGLE_MAIN_MENU', this.isOpenMenu)
    },
    changeSelectedLang (code) {
      this.$store.commit('changeLang', { code: code })
      window.location.reload()
    }
  },
  created () {
    let token = this.$store.getters.token
    this.$store.dispatch('getProfile', { token: token })
  }
}
</script>

<style scoped>
  .other-logo {
    text-align:center;
  }
  img.app-logo {
    height:40px
  }
  .other-logo img {
    height:36px
  }
</style>